export default __webpack_public_path__ + "static/media/foodz@2x.52588754.png";